"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f105 = void 0;
exports.f105 = {
    "it": [
        12,
        13,
        1326,
        1471,
        1539,
        1788,
        2068,
        2311,
        2312,
        2494,
        3202,
        3211,
        3249,
        3260,
        3261,
        3269,
        4333,
        4377,
        4409,
        4779,
        5299,
        5675,
        5971,
        5972,
        6117,
        6218,
        6509,
        6713,
        6718,
        6730,
        6740,
        6749,
        6758,
        7114,
        7220,
        8069,
        8623,
        8677,
        8678,
        8685,
        8688,
        8689
    ],
    "italy": [
        12,
        13,
        1326,
        1471,
        1539,
        1788,
        2068,
        2311,
        2312,
        2494,
        3202,
        3211,
        3249,
        3260,
        3261,
        3269,
        4333,
        4377,
        4409,
        4779,
        5299,
        5675,
        5971,
        5972,
        6117,
        6218,
        6509,
        6713,
        6718,
        6730,
        6740,
        6749,
        6758,
        7114,
        7220,
        8069,
        8623,
        8677,
        8678,
        8685,
        8688,
        8689
    ],
    "in": [
        3240,
        8787,
        14,
        41,
        67,
        68,
        69,
        94,
        97,
        158,
        189,
        191,
        207,
        210,
        229,
        241,
        244,
        254,
        255,
        267,
        327,
        330,
        331,
        332,
        333,
        363,
        385,
        388,
        459,
        476,
        546,
        706,
        719,
        743,
        759,
        760,
        761,
        762,
        763,
        769,
        770,
        771,
        773,
        774,
        781,
        782,
        783,
        785,
        794,
        795,
        800,
        805,
        806,
        807,
        809,
        810,
        817,
        822,
        823,
        828,
        829,
        830,
        833,
        853,
        856,
        857,
        868,
        894,
        971,
        990,
        998,
        1047,
        1048,
        1077,
        1107,
        1108,
        1109,
        1110,
        1111,
        1344,
        1382,
        1383,
        1387,
        1388,
        1389,
        1390,
        1391,
        1392,
        1393,
        1394,
        1397,
        1404,
        1429,
        1469,
        1470,
        1520,
        1541,
        1621,
        1671,
        1675,
        1700,
        1701,
        1739,
        1768,
        1769,
        1808,
        1809,
        1829,
        1837,
        1838,
        1861,
        1862,
        1895,
        1936,
        1937,
        1938,
        1956,
        1974,
        1996,
        2001,
        2002,
        2023,
        2113,
        2165,
        2246,
        2287,
        2288,
        2289,
        2404,
        2510,
        2528,
        2530,
        2532,
        2548,
        2549,
        2550,
        2551,
        2552,
        2553,
        2574,
        2575,
        2576,
        2596,
        2666,
        2705,
        2733,
        2734,
        2736,
        2737,
        2738,
        2739,
        2740,
        2741,
        2761,
        2762,
        2777,
        2778,
        2779,
        2800,
        2801,
        2802,
        2838,
        2891,
        2892,
        2916,
        2933,
        2934,
        2935,
        2936,
        2944,
        2945,
        2958,
        2959,
        2960,
        2965,
        2990,
        3001,
        3019,
        3020,
        3021,
        3022,
        3023,
        3028,
        3038,
        3045,
        3054,
        3135,
        3205,
        3224,
        3241,
        3242,
        3339,
        3384,
        3400,
        3406,
        3407,
        3408,
        3409,
        3435,
        3443,
        3483,
        3547,
        3567,
        3573,
        3574,
        3579,
        3580,
        3582,
        3583,
        3584,
        3586,
        3587,
        3588,
        3589,
        3590,
        3591,
        3592,
        3593,
        3594,
        3595,
        3596,
        3597,
        3598,
        3599,
        3601,
        3602,
        3607,
        3608,
        3609,
        3610,
        3611,
        3612,
        3613,
        3614,
        3615,
        3616,
        3617,
        3618,
        3643,
        3644,
        3655,
        3660,
        3661,
        3663,
        3691,
        3712,
        3741,
        3802,
        3805,
        3818,
        3819,
        3820,
        3832,
        3833,
        3861,
        3874,
        3944,
        3950,
        3951,
        3952,
        3953,
        3974,
        3979,
        3980,
        4095,
        4116,
        4122,
        4123,
        4124,
        4156,
        4157,
        4158,
        4192,
        4193,
        4199,
        4213,
        4214,
        4218,
        4222,
        4226,
        4228,
        4280,
        4281,
        4316,
        4330,
        4403,
        4404,
        4406,
        4407,
        4408,
        4494,
        4533,
        4535,
        4562,
        4576,
        4577,
        4578,
        4579,
        4580,
        4767,
        4785,
        4827,
        4828,
        4831,
        4832,
        4833,
        4834,
        4836,
        4838,
        4839,
        4840,
        4848,
        4850,
        4854,
        4872,
        4873,
        4874,
        4910,
        4911,
        4943,
        4944,
        4945,
        5036,
        5037,
        5038,
        5045,
        5046,
        5047,
        5048,
        5058,
        5118,
        5143,
        5145,
        5190,
        5191,
        5214,
        5239,
        5288,
        5312,
        5314,
        5315,
        5317,
        5327,
        5328,
        5329,
        5334,
        5335,
        5353,
        5354,
        5387,
        5394,
        5405,
        5452,
        5477,
        5485,
        5494,
        5496,
        5500,
        5501,
        5502,
        5509,
        5510,
        5512,
        5514,
        5516,
        5518,
        5519,
        5520,
        5551,
        5558,
        5561,
        5565,
        5566,
        5569,
        5577,
        5578,
        5597,
        5598,
        5603,
        5606,
        5607,
        5608,
        5622,
        5626,
        5644,
        5647,
        5649,
        5666,
        5669,
        5676,
        5681,
        5693,
        5702,
        5817,
        5879,
        5913,
        5914,
        5929,
        5930,
        5939,
        5948,
        5949,
        5959,
        5996,
        6012,
        6013,
        6014,
        6058,
        6067,
        6068,
        6069,
        6070,
        6071,
        6072,
        6073,
        6074,
        6075,
        6076,
        6094,
        6113,
        6122,
        6125,
        6138,
        6139,
        6140,
        6141,
        6167,
        6176,
        6208,
        6221,
        6296,
        6303,
        6304,
        6324,
        6325,
        6347,
        6353,
        6355,
        6381,
        6460,
        6461,
        6463,
        6464,
        6466,
        6496,
        6508,
        6517,
        6565,
        6570,
        6572,
        6609,
        6623,
        6643,
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657,
        6676,
        6677,
        6679,
        6680,
        6687,
        6688,
        6689,
        6690,
        6711,
        6712,
        6724,
        6726,
        6727,
        6729,
        6737,
        6742,
        6743,
        6744,
        6746,
        6760,
        6816,
        6820,
        6843,
        6874,
        6879,
        6895,
        6903,
        6904,
        6943,
        6982,
        6984,
        7064,
        7066,
        7101,
        7102,
        7103,
        7104,
        7123,
        7124,
        7137,
        7139,
        7160,
        7202,
        7203,
        7204,
        7249,
        7296,
        7297,
        7375,
        7376,
        7377,
        7378,
        7382,
        7383,
        7384,
        7407,
        7408,
        7414,
        7454,
        7478,
        7537,
        7674,
        7703,
        7713,
        7714,
        7715,
        7725,
        7813,
        7828,
        7850,
        7851,
        7852,
        7907,
        7935,
        7951,
        7976,
        7977,
        7979,
        7981,
        7982,
        7983,
        7989,
        7990,
        8001,
        8045,
        8049,
        8057,
        8059,
        8060,
        8062,
        8063,
        8087,
        8097,
        8098,
        8107,
        8188,
        8189,
        8190,
        8247,
        8249,
        8251,
        8340,
        8343,
        8344,
        8345,
        8346,
        8357,
        8391,
        8487,
        8567,
        8568,
        8661,
        8669,
        8670,
        8671,
        8672,
        8675,
        8768,
        8769,
        8778,
        8803,
        8854,
        8989,
        9115,
        9149,
        9150
    ],
    "india": [
        4122,
        5239,
        331,
        332,
        362,
        363,
        1109,
        1110,
        1111,
        3384,
        3590,
        3805,
        4767,
        5058,
        5566,
        6517,
        6643,
        7935,
        14,
        41,
        67,
        68,
        69,
        94,
        97,
        158,
        189,
        191,
        207,
        210,
        229,
        241,
        244,
        254,
        255,
        267,
        327,
        330,
        333,
        385,
        388,
        459,
        476,
        546,
        706,
        719,
        743,
        759,
        760,
        761,
        762,
        763,
        769,
        770,
        771,
        773,
        774,
        781,
        782,
        783,
        785,
        794,
        795,
        800,
        805,
        806,
        807,
        809,
        810,
        817,
        822,
        823,
        828,
        829,
        830,
        833,
        853,
        856,
        857,
        868,
        894,
        971,
        990,
        998,
        1047,
        1048,
        1077,
        1107,
        1108,
        1344,
        1382,
        1383,
        1387,
        1388,
        1389,
        1390,
        1391,
        1392,
        1393,
        1394,
        1397,
        1404,
        1429,
        1469,
        1470,
        1520,
        1541,
        1621,
        1671,
        1675,
        1700,
        1701,
        1739,
        1768,
        1769,
        1808,
        1809,
        1829,
        1837,
        1838,
        1861,
        1862,
        1895,
        1936,
        1937,
        1938,
        1956,
        1974,
        1996,
        2001,
        2002,
        2023,
        2113,
        2165,
        2246,
        2287,
        2288,
        2289,
        2404,
        2510,
        2528,
        2530,
        2532,
        2548,
        2549,
        2550,
        2551,
        2552,
        2553,
        2574,
        2575,
        2576,
        2596,
        2666,
        2705,
        2733,
        2734,
        2736,
        2737,
        2738,
        2739,
        2740,
        2741,
        2761,
        2762,
        2777,
        2778,
        2779,
        2800,
        2801,
        2802,
        2838,
        2891,
        2892,
        2916,
        2933,
        2934,
        2935,
        2936,
        2944,
        2945,
        2958,
        2959,
        2960,
        2965,
        2990,
        3001,
        3019,
        3020,
        3021,
        3022,
        3023,
        3028,
        3038,
        3045,
        3054,
        3135,
        3205,
        3224,
        3241,
        3242,
        3339,
        3400,
        3406,
        3407,
        3408,
        3409,
        3435,
        3443,
        3483,
        3547,
        3567,
        3573,
        3574,
        3579,
        3580,
        3582,
        3583,
        3584,
        3586,
        3587,
        3588,
        3589,
        3591,
        3592,
        3593,
        3594,
        3595,
        3596,
        3597,
        3598,
        3599,
        3601,
        3602,
        3607,
        3608,
        3609,
        3610,
        3611,
        3612,
        3613,
        3614,
        3615,
        3616,
        3617,
        3618,
        3643,
        3644,
        3655,
        3660,
        3661,
        3663,
        3691,
        3712,
        3741,
        3802,
        3818,
        3819,
        3820,
        3832,
        3833,
        3861,
        3874,
        3944,
        3950,
        3951,
        3952,
        3953,
        3974,
        3979,
        3980,
        4095,
        4116,
        4123,
        4124,
        4156,
        4157,
        4158,
        4192,
        4193,
        4199,
        4213,
        4214,
        4218,
        4222,
        4226,
        4228,
        4280,
        4281,
        4316,
        4330,
        4403,
        4404,
        4406,
        4407,
        4408,
        4494,
        4533,
        4535,
        4562,
        4576,
        4577,
        4578,
        4579,
        4580,
        4785,
        4827,
        4828,
        4831,
        4832,
        4833,
        4834,
        4836,
        4838,
        4839,
        4840,
        4848,
        4850,
        4854,
        4872,
        4873,
        4874,
        4910,
        4911,
        4943,
        4944,
        4945,
        5036,
        5037,
        5038,
        5045,
        5046,
        5047,
        5048,
        5118,
        5143,
        5145,
        5190,
        5191,
        5214,
        5288,
        5312,
        5314,
        5315,
        5317,
        5327,
        5328,
        5329,
        5334,
        5335,
        5353,
        5354,
        5387,
        5394,
        5405,
        5452,
        5477,
        5485,
        5494,
        5496,
        5500,
        5501,
        5502,
        5509,
        5510,
        5512,
        5514,
        5516,
        5518,
        5519,
        5520,
        5551,
        5558,
        5561,
        5565,
        5569,
        5577,
        5578,
        5597,
        5598,
        5603,
        5606,
        5607,
        5608,
        5622,
        5626,
        5644,
        5647,
        5649,
        5666,
        5669,
        5676,
        5681,
        5693,
        5702,
        5817,
        5879,
        5913,
        5914,
        5929,
        5930,
        5939,
        5948,
        5949,
        5959,
        5996,
        6012,
        6013,
        6014,
        6058,
        6067,
        6068,
        6069,
        6070,
        6071,
        6072,
        6073,
        6074,
        6075,
        6076,
        6094,
        6113,
        6122,
        6125,
        6138,
        6139,
        6140,
        6141,
        6167,
        6176,
        6208,
        6221,
        6296,
        6303,
        6304,
        6324,
        6325,
        6347,
        6353,
        6355,
        6381,
        6460,
        6461,
        6463,
        6464,
        6466,
        6496,
        6508,
        6565,
        6570,
        6572,
        6609,
        6623,
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657,
        6676,
        6677,
        6679,
        6680,
        6687,
        6688,
        6689,
        6690,
        6711,
        6712,
        6724,
        6726,
        6727,
        6729,
        6737,
        6742,
        6743,
        6744,
        6746,
        6760,
        6816,
        6820,
        6843,
        6874,
        6879,
        6895,
        6903,
        6904,
        6943,
        6982,
        6984,
        7064,
        7066,
        7101,
        7102,
        7103,
        7104,
        7123,
        7124,
        7137,
        7139,
        7160,
        7202,
        7203,
        7204,
        7249,
        7296,
        7297,
        7375,
        7376,
        7377,
        7378,
        7382,
        7383,
        7384,
        7407,
        7408,
        7414,
        7454,
        7478,
        7537,
        7674,
        7703,
        7713,
        7714,
        7715,
        7725,
        7813,
        7828,
        7850,
        7851,
        7852,
        7907,
        7951,
        7976,
        7977,
        7979,
        7981,
        7982,
        7983,
        7989,
        7990,
        8001,
        8045,
        8049,
        8057,
        8059,
        8060,
        8062,
        8063,
        8087,
        8097,
        8098,
        8107,
        8188,
        8189,
        8190,
        8247,
        8249,
        8251,
        8340,
        8343,
        8344,
        8345,
        8346,
        8357,
        8391,
        8487,
        8567,
        8568,
        8661,
        8669,
        8670,
        8671,
        8672,
        8675,
        8768,
        8769,
        8778,
        8803,
        8854,
        8989,
        9115,
        9149,
        9150
    ],
    "id": [
        28,
        29,
        42,
        50,
        59,
        63,
        64,
        98,
        101,
        149,
        155,
        179,
        211,
        213,
        232,
        233,
        234,
        238,
        271,
        272,
        295,
        301,
        306,
        318,
        357,
        361,
        366,
        375,
        392,
        399,
        462,
        468,
        471,
        483,
        484,
        500,
        524,
        527,
        528,
        551,
        557,
        558,
        560,
        561,
        564,
        591,
        612,
        617,
        620,
        621,
        622,
        632,
        635,
        636,
        663,
        686,
        696,
        707,
        708,
        718,
        723,
        730,
        734,
        736,
        746,
        748,
        780,
        799,
        803,
        804,
        808,
        824,
        825,
        831,
        832,
        835,
        872,
        873,
        895,
        897,
        901,
        910,
        915,
        917,
        920,
        932,
        940,
        973,
        976,
        977,
        978,
        988,
        991,
        992,
        1030,
        1038,
        1039,
        1040,
        1045,
        1049,
        1051,
        1066,
        1067,
        1074,
        1095,
        1098,
        1116,
        1128,
        1138,
        1147,
        1152,
        1153,
        1154,
        1160,
        1161,
        1166,
        1167,
        1168,
        1169,
        1177,
        1178,
        1186,
        1200,
        1206,
        1214,
        1215,
        1220,
        1238,
        1274,
        1282,
        1297,
        1308,
        1310,
        1312,
        1313,
        1317,
        1462,
        1463,
        1464,
        1533,
        1554,
        1746,
        1750,
        1751,
        1758,
        1781,
        1799,
        1803,
        1853,
        1866,
        1882,
        1888,
        1907,
        1908,
        1909,
        1913,
        1914,
        1918,
        1921,
        1925,
        1928,
        1939,
        1961,
        1973,
        2007,
        2009,
        2010,
        2014,
        2015,
        2051,
        2073,
        2081,
        2103,
        2114,
        2230,
        2236,
        2238,
        2254,
        2255,
        2315,
        2345,
        2397,
        2467,
        2520,
        2538,
        2547,
        2601,
        2604,
        2609,
        2743,
        2744,
        2745,
        2776,
        2873,
        2885,
        2900,
        2924,
        2947,
        2955,
        2993,
        3036,
        3049,
        3065,
        3068,
        3074,
        3081,
        3092,
        3099,
        3125,
        3131,
        3132,
        3133,
        3165,
        3167,
        3192,
        3203,
        3210,
        3219,
        3235,
        3236,
        3243,
        3254,
        3266,
        3278,
        3292,
        3314,
        3318,
        3321,
        3322,
        3327,
        3332,
        3348,
        3350,
        3380,
        3392,
        3444,
        3445,
        3446,
        3476,
        3485,
        3500,
        3509,
        3554,
        3556,
        3566,
        3622,
        3623,
        3634,
        3635,
        3639,
        3640,
        3641,
        3647,
        3648,
        3649,
        3652,
        3658,
        3677,
        3685,
        3692,
        3696,
        3698,
        3700,
        3708,
        3720,
        3736,
        3748,
        3758,
        3760,
        3772,
        3787,
        3789,
        3790,
        3811,
        3823,
        3830,
        3844,
        3853,
        3876,
        3882,
        3889,
        3891,
        3893,
        3919,
        3949,
        3978,
        3990,
        3999,
        4000,
        4016,
        4024,
        4036,
        4046,
        4048,
        4052,
        4059,
        4060,
        4063,
        4064,
        4067,
        4068,
        4071,
        4077,
        4080,
        4089,
        4091,
        4118,
        4135,
        4146,
        4151,
        4163,
        4165,
        4167,
        4171,
        4172,
        4175,
        4179,
        4180,
        4182,
        4184,
        4211,
        4212,
        4238,
        4239,
        4242,
        4243,
        4244,
        4245,
        4247,
        4250,
        4251,
        4287,
        4288,
        4289,
        4290,
        4303,
        4314,
        4337,
        4345,
        4346,
        4350,
        4351,
        4352,
        4353,
        4354,
        4380,
        4386,
        4389,
        4398,
        4402,
        4411,
        4412,
        4417,
        4425,
        4440,
        4443,
        4464,
        4469,
        4483,
        4486,
        4512,
        4516,
        4532,
        4547,
        4549,
        4557,
        4573,
        4582,
        4583,
        4584,
        4598,
        4668,
        4669,
        4688,
        4709,
        4725,
        4745,
        4750,
        4781,
        4783,
        4788,
        4789,
        4805,
        4806,
        4859,
        4870,
        4882,
        4900,
        4934,
        4954,
        4957,
        4959,
        4964,
        4968,
        4972,
        5008,
        5010,
        5012,
        5014,
        5015,
        5017,
        5018,
        5022,
        5023,
        5024,
        5026,
        5027,
        5032,
        5033,
        5034,
        5044,
        5064,
        5066,
        5072,
        5078,
        5079,
        5084,
        5087,
        5091,
        5104,
        5107,
        5108,
        5110,
        5133,
        5152,
        5164,
        5166,
        5167,
        5172,
        5196,
        5208,
        5218,
        5230,
        5242,
        5272,
        5283,
        5286,
        5321,
        5324,
        5381,
        5389,
        5391,
        5404,
        5415,
        5468,
        5476,
        5478,
        5483,
        5504,
        5521,
        5529,
        5545,
        5550,
        5600,
        5648,
        5651,
        5655,
        5708,
        5735,
        5773,
        5774,
        5777,
        5785,
        5857,
        5924,
        5936,
        5943,
        5964,
        5973,
        5982,
        6036,
        6084,
        6085,
        6089,
        6092,
        6099,
        6106,
        6119,
        6179,
        6186,
        6188,
        6207,
        6215,
        6222,
        6225,
        6230,
        6237,
        6240,
        6270,
        6272,
        6301,
        6308,
        6311,
        6317,
        6344,
        6349,
        6350,
        6356,
        6357,
        6359,
        6362,
        6369,
        6456,
        6468,
        6485,
        6493,
        6497,
        6498,
        6504,
        6512,
        6526,
        6528,
        6529,
        6547,
        6552,
        6571,
        6581,
        6593,
        6595,
        6606,
        6666,
        6671,
        6674,
        6675,
        6681,
        6684,
        6697,
        6708,
        6710,
        6715,
        6723,
        6747,
        6757,
        6761,
        6767,
        6793,
        6794,
        6810,
        6824,
        6890,
        6919,
        6920,
        6924,
        6934,
        6936,
        6938,
        6945,
        6952,
        6957,
        6960,
        6961,
        6979,
        6985,
        7011,
        7025,
        7049,
        7054,
        7062,
        7105,
        7111,
        7119,
        7122,
        7145,
        7161,
        7183,
        7184,
        7185,
        7186,
        7218,
        7245,
        7246,
        7247,
        7248,
        7260,
        7266,
        7283,
        7289,
        7290,
        7294,
        7304,
        7344,
        7353,
        7361,
        7366,
        7370,
        7393,
        7394,
        7398,
        7402,
        7426,
        7429,
        7439,
        7441,
        7510,
        7521,
        7554,
        7561,
        7563,
        7565,
        7571,
        7574,
        7580,
        7581,
        7582,
        7593,
        7598,
        7600,
        7602,
        7608,
        7621,
        7624,
        7631,
        7634,
        7648,
        7658,
        7664,
        7665,
        7704,
        7719,
        7763,
        7768,
        7770,
        7779,
        7792,
        7806,
        7809,
        7811,
        7815,
        7822,
        7824,
        7835,
        7838,
        7843,
        7848,
        7849,
        7853,
        7855,
        7856,
        7868,
        7887,
        7909,
        7914,
        7927,
        7932,
        7948,
        7952,
        7954,
        7967,
        7984,
        8003,
        8012,
        8065,
        8092,
        8093,
        8096,
        8099,
        8108,
        8120,
        8142,
        8151,
        8155,
        8156,
        8176,
        8177,
        8193,
        8209,
        8213,
        8215,
        8216,
        8221,
        8224,
        8226,
        8227,
        8248,
        8259,
        8263,
        8268,
        8279,
        8282,
        8291,
        8294,
        8297,
        8307,
        8313,
        8317,
        8318,
        8320,
        8333,
        8336,
        8339,
        8342,
        8358,
        8359,
        8364,
        8374,
        8408,
        8411,
        8424,
        8449,
        8454,
        8495,
        8496,
        8502,
        8503,
        8506,
        8508,
        8512,
        8542,
        8549,
        8553,
        8555,
        8576,
        8631,
        8649,
        8699,
        8703,
        8706,
        8719,
        8777,
        8807,
        8817,
        8831,
        8850,
        8900,
        8943,
        9000,
        9029,
        9059,
        9154
    ],
    "indonesia": [
        3131,
        835,
        976,
        1214,
        1313,
        3132,
        3133,
        3500,
        4048,
        4314,
        4512,
        4783,
        5010,
        5218,
        7049,
        7602,
        7822,
        8279,
        28,
        29,
        42,
        50,
        59,
        63,
        64,
        98,
        101,
        149,
        155,
        179,
        211,
        213,
        232,
        233,
        234,
        238,
        271,
        272,
        295,
        301,
        306,
        318,
        357,
        361,
        366,
        375,
        392,
        399,
        462,
        468,
        471,
        483,
        484,
        500,
        524,
        527,
        528,
        551,
        557,
        558,
        560,
        561,
        564,
        591,
        612,
        617,
        620,
        621,
        622,
        632,
        635,
        636,
        663,
        686,
        696,
        707,
        708,
        718,
        723,
        730,
        734,
        736,
        746,
        748,
        780,
        799,
        803,
        804,
        808,
        824,
        825,
        831,
        832,
        872,
        873,
        895,
        897,
        901,
        910,
        915,
        917,
        920,
        932,
        940,
        973,
        977,
        978,
        988,
        991,
        992,
        1030,
        1038,
        1039,
        1040,
        1045,
        1049,
        1051,
        1066,
        1067,
        1074,
        1095,
        1098,
        1116,
        1128,
        1138,
        1147,
        1152,
        1153,
        1154,
        1160,
        1161,
        1166,
        1167,
        1168,
        1169,
        1177,
        1178,
        1186,
        1200,
        1206,
        1215,
        1220,
        1238,
        1274,
        1282,
        1297,
        1308,
        1310,
        1312,
        1317,
        1462,
        1463,
        1464,
        1533,
        1554,
        1746,
        1750,
        1751,
        1758,
        1781,
        1799,
        1803,
        1853,
        1866,
        1882,
        1888,
        1907,
        1908,
        1909,
        1913,
        1914,
        1918,
        1921,
        1925,
        1928,
        1939,
        1961,
        1973,
        2007,
        2009,
        2010,
        2014,
        2015,
        2051,
        2073,
        2081,
        2103,
        2114,
        2230,
        2236,
        2238,
        2254,
        2255,
        2315,
        2345,
        2397,
        2467,
        2520,
        2538,
        2547,
        2601,
        2604,
        2609,
        2743,
        2744,
        2745,
        2776,
        2873,
        2885,
        2900,
        2924,
        2947,
        2955,
        2993,
        3036,
        3049,
        3065,
        3068,
        3074,
        3081,
        3092,
        3099,
        3125,
        3165,
        3167,
        3192,
        3203,
        3210,
        3219,
        3235,
        3236,
        3243,
        3254,
        3266,
        3278,
        3292,
        3314,
        3318,
        3321,
        3322,
        3327,
        3332,
        3348,
        3350,
        3380,
        3392,
        3444,
        3445,
        3446,
        3476,
        3485,
        3509,
        3554,
        3556,
        3566,
        3622,
        3623,
        3634,
        3635,
        3639,
        3640,
        3641,
        3647,
        3648,
        3649,
        3652,
        3658,
        3677,
        3685,
        3692,
        3696,
        3698,
        3700,
        3708,
        3720,
        3736,
        3748,
        3758,
        3760,
        3772,
        3787,
        3789,
        3790,
        3811,
        3823,
        3830,
        3844,
        3853,
        3876,
        3882,
        3889,
        3891,
        3893,
        3919,
        3949,
        3978,
        3990,
        3999,
        4000,
        4016,
        4024,
        4036,
        4046,
        4052,
        4059,
        4060,
        4063,
        4064,
        4067,
        4068,
        4071,
        4077,
        4080,
        4089,
        4091,
        4118,
        4135,
        4146,
        4151,
        4163,
        4165,
        4167,
        4171,
        4172,
        4175,
        4179,
        4180,
        4182,
        4184,
        4211,
        4212,
        4238,
        4239,
        4242,
        4243,
        4244,
        4245,
        4247,
        4250,
        4251,
        4287,
        4288,
        4289,
        4290,
        4303,
        4337,
        4345,
        4346,
        4350,
        4351,
        4352,
        4353,
        4354,
        4380,
        4386,
        4389,
        4398,
        4402,
        4411,
        4412,
        4417,
        4425,
        4440,
        4443,
        4464,
        4469,
        4483,
        4486,
        4516,
        4532,
        4547,
        4549,
        4557,
        4573,
        4582,
        4583,
        4584,
        4598,
        4668,
        4669,
        4688,
        4709,
        4725,
        4745,
        4750,
        4781,
        4788,
        4789,
        4805,
        4806,
        4859,
        4870,
        4882,
        4900,
        4934,
        4954,
        4957,
        4959,
        4964,
        4968,
        4972,
        5008,
        5012,
        5014,
        5015,
        5017,
        5018,
        5022,
        5023,
        5024,
        5026,
        5027,
        5032,
        5033,
        5034,
        5044,
        5064,
        5066,
        5072,
        5078,
        5079,
        5084,
        5087,
        5091,
        5104,
        5107,
        5108,
        5110,
        5133,
        5152,
        5164,
        5166,
        5167,
        5172,
        5196,
        5208,
        5230,
        5242,
        5272,
        5283,
        5286,
        5321,
        5324,
        5381,
        5389,
        5391,
        5404,
        5415,
        5468,
        5476,
        5478,
        5483,
        5504,
        5521,
        5529,
        5545,
        5550,
        5600,
        5648,
        5651,
        5655,
        5708,
        5735,
        5773,
        5774,
        5777,
        5785,
        5857,
        5924,
        5936,
        5943,
        5964,
        5973,
        5982,
        6036,
        6084,
        6085,
        6089,
        6092,
        6099,
        6106,
        6119,
        6179,
        6186,
        6188,
        6207,
        6215,
        6222,
        6225,
        6230,
        6237,
        6240,
        6270,
        6272,
        6301,
        6308,
        6311,
        6317,
        6344,
        6349,
        6350,
        6356,
        6357,
        6359,
        6362,
        6369,
        6456,
        6468,
        6485,
        6493,
        6497,
        6498,
        6504,
        6512,
        6526,
        6528,
        6529,
        6547,
        6552,
        6571,
        6581,
        6593,
        6595,
        6606,
        6666,
        6671,
        6674,
        6675,
        6681,
        6684,
        6697,
        6708,
        6710,
        6715,
        6723,
        6747,
        6757,
        6761,
        6767,
        6793,
        6794,
        6810,
        6824,
        6890,
        6919,
        6920,
        6924,
        6934,
        6936,
        6938,
        6945,
        6952,
        6957,
        6960,
        6961,
        6979,
        6985,
        7011,
        7025,
        7054,
        7062,
        7105,
        7111,
        7119,
        7122,
        7145,
        7161,
        7183,
        7184,
        7185,
        7186,
        7218,
        7245,
        7246,
        7247,
        7248,
        7260,
        7266,
        7283,
        7289,
        7290,
        7294,
        7304,
        7344,
        7353,
        7361,
        7366,
        7370,
        7393,
        7394,
        7398,
        7402,
        7426,
        7429,
        7439,
        7441,
        7510,
        7521,
        7554,
        7561,
        7563,
        7565,
        7571,
        7574,
        7580,
        7581,
        7582,
        7593,
        7598,
        7600,
        7608,
        7621,
        7624,
        7631,
        7634,
        7648,
        7658,
        7664,
        7665,
        7704,
        7719,
        7763,
        7768,
        7770,
        7779,
        7792,
        7806,
        7809,
        7811,
        7815,
        7824,
        7835,
        7838,
        7843,
        7848,
        7849,
        7853,
        7855,
        7856,
        7868,
        7887,
        7909,
        7914,
        7927,
        7932,
        7948,
        7952,
        7954,
        7967,
        7984,
        8003,
        8012,
        8065,
        8092,
        8093,
        8096,
        8099,
        8108,
        8120,
        8142,
        8151,
        8155,
        8156,
        8176,
        8177,
        8193,
        8209,
        8213,
        8215,
        8216,
        8221,
        8224,
        8226,
        8227,
        8248,
        8259,
        8263,
        8268,
        8282,
        8291,
        8294,
        8297,
        8307,
        8313,
        8317,
        8318,
        8320,
        8333,
        8336,
        8339,
        8342,
        8358,
        8359,
        8364,
        8374,
        8408,
        8411,
        8424,
        8449,
        8454,
        8495,
        8496,
        8502,
        8503,
        8506,
        8508,
        8512,
        8542,
        8549,
        8553,
        8555,
        8576,
        8631,
        8649,
        8699,
        8703,
        8706,
        8719,
        8777,
        8807,
        8817,
        8831,
        8850,
        8900,
        8943,
        9000,
        9029,
        9059,
        9154
    ],
    "inabaknon": [
        57
    ],
    "iraqi arabic": [
        70
    ],
    "iraqi": [
        70,
        8791
    ],
    "iq": [
        70,
        203,
        242,
        415,
        585,
        595,
        871,
        1496,
        1498,
        3901,
        4008,
        4011,
        4476,
        4795,
        4811,
        6748,
        6751,
        7277
    ],
    "iraq": [
        70,
        203,
        242,
        415,
        585,
        595,
        871,
        1496,
        1498,
        3901,
        4008,
        4011,
        4476,
        4795,
        4811,
        6748,
        6751,
        7277
    ],
    "ir": [
        3240,
        112,
        113,
        114,
        435,
        497,
        534,
        593,
        596,
        599,
        1058,
        1121,
        1497,
        1796,
        2101,
        2290,
        2329,
        2347,
        2348,
        2564,
        2680,
        2681,
        2752,
        2872,
        2884,
        3057,
        3604,
        3631,
        3656,
        3657,
        3732,
        3773,
        3817,
        3993,
        4363,
        4475,
        4481,
        4489,
        4541,
        5254,
        5269,
        5724,
        5803,
        5877,
        6028,
        6101,
        6285,
        6309,
        6443,
        6474,
        6491,
        6560,
        6753,
        6821,
        6844,
        6887,
        6953,
        6987,
        7035,
        7080,
        7126,
        7275,
        7534,
        7549,
        7655,
        7774,
        8047,
        8111,
        8494,
        8500,
        8505,
        8529,
        8604,
        8659,
        8660
    ],
    "islamic republic of iran": [
        112,
        113,
        114,
        435,
        497,
        534,
        593,
        596,
        599,
        1058,
        1121,
        1497,
        1796,
        2101,
        2290,
        2329,
        2347,
        2348,
        2564,
        2680,
        2681,
        2752,
        2872,
        2884,
        3057,
        3604,
        3631,
        3656,
        3657,
        3732,
        3773,
        3817,
        3993,
        4363,
        4475,
        4481,
        4489,
        4541,
        5254,
        5269,
        5724,
        5803,
        5877,
        6028,
        6101,
        6285,
        6309,
        6443,
        6474,
        6491,
        6560,
        6753,
        6821,
        6844,
        6887,
        6953,
        6987,
        7035,
        7080,
        7126,
        7275,
        7534,
        7549,
        7655,
        7774,
        8047,
        8111,
        8494,
        8500,
        8505,
        8529,
        8604,
        8659,
        8660
    ],
    "islamic": [
        112,
        113,
        114,
        435,
        497,
        534,
        593,
        596,
        599,
        1058,
        1121,
        1497,
        1796,
        2101,
        2290,
        2329,
        2347,
        2348,
        2564,
        2680,
        2681,
        2752,
        2872,
        2884,
        3057,
        3604,
        3631,
        3656,
        3657,
        3732,
        3773,
        3817,
        3993,
        4363,
        4475,
        4481,
        4489,
        4541,
        5254,
        5269,
        5724,
        5803,
        5877,
        6028,
        6101,
        6285,
        6309,
        6443,
        6474,
        6491,
        6560,
        6753,
        6821,
        6844,
        6887,
        6953,
        6987,
        7035,
        7080,
        7126,
        7275,
        7534,
        7549,
        7655,
        7774,
        8047,
        8111,
        8494,
        8500,
        8505,
        8529,
        8604,
        8659,
        8660
    ],
    "iran": [
        112,
        113,
        114,
        435,
        497,
        534,
        593,
        596,
        599,
        1058,
        1121,
        1497,
        1796,
        2101,
        2290,
        2329,
        2347,
        2348,
        2564,
        2680,
        2681,
        2752,
        2872,
        2884,
        3057,
        3604,
        3631,
        3656,
        3657,
        3732,
        3773,
        3817,
        3993,
        4363,
        4475,
        4481,
        4489,
        4541,
        5254,
        5269,
        5724,
        5803,
        5877,
        6028,
        6101,
        6285,
        6309,
        6443,
        6474,
        6491,
        6560,
        6753,
        6821,
        6844,
        6887,
        6953,
        6987,
        7035,
        7080,
        7126,
        7275,
        7534,
        7549,
        7655,
        7774,
        8047,
        8111,
        8494,
        8500,
        8505,
        8529,
        8604,
        8659,
        8660
    ],
    "igbo": [
        3154,
        151
    ],
    "igbo imaban": [
        151
    ],
    "imaban": [
        151
    ],
    "itigidi": [
        151
    ],
    "idoma": [
        3143,
        257,
        152
    ],
    "inagta partido": [
        161
    ],
    "inagta": [
        2005,
        161,
        495,
        175
    ],
    "isarog agta": [
        161
    ],
    "isarog": [
        161
    ],
    "ivori": [
        165
    ],
    "isimbi": [
        168
    ],
    "islands": [
        1560,
        6472,
        7291,
        7292,
        8081,
        3786,
        4789,
        5105,
        5417,
        5547,
        7638,
        8025,
        172,
        194,
        277,
        367,
        510,
        513,
        610,
        797,
        913,
        926,
        1097,
        1198,
        1199,
        1248,
        1339,
        1770,
        1945,
        2136,
        2138,
        2151,
        2172,
        2177,
        2179,
        2199,
        2211,
        2218,
        2220,
        2221,
        2274,
        2334,
        2344,
        2408,
        2617,
        2633,
        2689,
        2770,
        3017,
        3312,
        3706,
        3747,
        3960,
        4076,
        4078,
        4170,
        4298,
        4299,
        4305,
        4309,
        4311,
        4391,
        4546,
        4766,
        4887,
        4894,
        4955,
        5001,
        5053,
        5071,
        5163,
        5436,
        5515,
        5560,
        5650,
        5720,
        5867,
        5950,
        6158,
        6161,
        6175,
        6229,
        6534,
        6598,
        6602,
        6622,
        6692,
        6937,
        7171,
        7210,
        7221,
        7332,
        7362,
        7545,
        7553,
        7578,
        7635,
        7678,
        7692,
        7804,
        7922,
        8128,
        8137
    ],
    "ita": [
        174
    ],
    "iriga": [
        175,
        1156
    ],
    "ikor": [
        181,
        182,
        183,
        184,
        185
    ],
    "igo": [
        186
    ],
    "ishe": [
        192
    ],
    "ishɛ": [
        192
    ],
    "inter-zab jewish neo-aramaic": [
        204
    ],
    "inter-zab": [
        204
    ],
    "il": [
        204,
        226,
        414,
        814,
        815,
        816,
        863,
        2163,
        2914,
        2921,
        2922,
        3094,
        3257,
        3325,
        3357,
        3417,
        3421,
        3450,
        4189,
        4491,
        6975,
        7087,
        7281,
        7605,
        7706,
        8773,
        8791,
        8922
    ],
    "israel": [
        282,
        283,
        284,
        204,
        226,
        414,
        814,
        815,
        816,
        863,
        2163,
        2914,
        2921,
        2922,
        3094,
        3257,
        3325,
        3357,
        3417,
        3421,
        3450,
        4189,
        4491,
        6975,
        7087,
        7281,
        7605,
        7706,
        8773,
        8791,
        8922
    ],
    "itak": [
        208,
        209
    ],
    "iriemkena": [
        213
    ],
    "il‘arabiyya dyalna": [
        227,
        3421
    ],
    "il‘arabiyya": [
        227,
        3421
    ],
    "ingariko": [
        236,
        6044
    ],
    "ingarikó": [
        236
    ],
    "inakeanon": [
        243
    ],
    "innaaɬiilka": [
        256
    ],
    "idoma nokwu": [
        257
    ],
    "iliaura": [
        280
    ],
    "ipitineri": [
        287
    ],
    "ipitnere": [
        287
    ],
    "ingura": [
        352
    ],
    "il-lahje š-šāmiyye": [
        368
    ],
    "il-lahje": [
        368
    ],
    "ipurinã": [
        389
    ],
    "ipurinãn": [
        389
    ],
    "ilputih": [
        392
    ],
    "imperial aramaic (700-300 bce)": [
        435,
        436,
        437,
        438
    ],
    "imperial": [
        435,
        436,
        437,
        438
    ],
    "iku": [
        441,
        3188
    ],
    "ica": [
        3127,
        441
    ],
    "ijca": [
        441
    ],
    "ijka": [
        441
    ],
    "ika": [
        3180,
        441
    ],
    "ikan": [
        441
    ],
    "ike": [
        441
    ],
    "ikʉ": [
        441
    ],
    "itogapuc": [
        450
    ],
    "itogapúk": [
        450
    ],
    "ivoirienne": [
        463,
        464
    ],
    "ixignor": [
        467
    ],
    "ipulo": [
        477
    ],
    "ipulo-olulu": [
        477
    ],
    "ivbie north-okpela-arhe": [
        491
    ],
    "ivbie": [
        491
    ],
    "inati": [
        494
    ],
    "iraya": [
        3244,
        495
    ],
    "inagta of mt. iraya": [
        495
    ],
    "itbeg rugnot": [
        495
    ],
    "itbeg": [
        495
    ],
    "inata": [
        496
    ],
    "iara": [
        501
    ],
    "indians": [
        502
    ],
    "intas anejom": [
        508
    ],
    "intas": [
        508
    ],
    "indios negros": [
        545
    ],
    "indios": [
        545,
        3931,
        7251
    ],
    "iluwu": [
        577
    ],
    "ipalapa": [
        604
    ],
    "ipalapa amuzgo": [
        604
    ],
    "ihini": [
        613,
        4784
    ],
    "iyongiyong": [
        652
    ],
    "iyoniyong": [
        652,
        3749
    ],
    "i": [
        4235,
        8882,
        656,
        9146,
        9147
    ],
    "ibaali": [
        672
    ],
    "indonesian": [
        3131,
        3132,
        3133,
        3219,
        4725,
        6089,
        696
    ],
    "indonesian bajau": [
        696
    ],
    "indonesian bajaw": [
        696
    ],
    "iso": [
        703
    ],
    "iceve-maci": [
        717
    ],
    "iceve": [
        717
    ],
    "icheve": [
        717
    ],
    "ichibemba": [
        727,
        728
    ],
    "icibemba": [
        727,
        728
    ],
    "ikibena": [
        740
    ],
    "indorodoro": [
        749
    ],
    "isal": [
        803
    ],
    "ioma binandere": [
        813
    ],
    "ioma": [
        813
    ],
    "ikke lo": [
        818
    ],
    "ikke": [
        818
    ],
    "ipere": [
        834
    ],
    "iniai": [
        851,
        5406
    ],
    "inyai-gadio-bisorio": [
        851
    ],
    "inaru": [
        865
    ],
    "itneg, banao": [
        883
    ],
    "itneg": [
        883,
        3265,
        3268,
        3275,
        3279,
        7512,
        7514,
        3742
    ],
    "ibeeke": [
        889
    ],
    "ipande": [
        893
    ],
    "itangikom": [
        896
    ],
    "iboko": [
        899
    ],
    "ikinyikiusa": [
        910,
        5811
    ],
    "ipala": [
        936
    ],
    "indi": [
        938
    ],
    "indi ayta": [
        938
    ],
    "ibembe": [
        945
    ],
    "igorot": [
        975,
        8564
    ],
    "impfondo": [
        1010
    ],
    "iski": [
        1096,
        3157,
        6549,
        8578
    ],
    "iriga bicolano": [
        1156
    ],
    "ibhubhi": [
        1192
    ],
    "ibubi": [
        1192
    ],
    "içana": [
        1230,
        4921
    ],
    "issana": [
        1230
    ],
    "ibwisi": [
        1247
    ],
    "ibin": [
        1280
    ],
    "imbao’o": [
        1297
    ],
    "island carib": [
        1599,
        1329
    ],
    "island": [
        1599,
        2297,
        2298,
        2400,
        2813,
        8612,
        1329,
        1626,
        4773,
        2005,
        4546,
        4652,
        4897,
        5129,
        6470,
        6472,
        7221,
        2140,
        2186,
        6149
    ],
    "ixtatán": [
        1330
    ],
    "izora": [
        1362
    ],
    "incauncanibo": [
        1364
    ],
    "i-hadja": [
        1377
    ],
    "ishir": [
        1411
    ],
    "ishiro": [
        1411
    ],
    "ibaas": [
        1422
    ],
    "icen": [
        1422,
        3128
    ],
    "icen fiforon": [
        1422
    ],
    "icen ibaas": [
        1422
    ],
    "ichen": [
        1422,
        3128
    ],
    "itchen": [
        1422,
        3128
    ],
    "islam": [
        1478
    ],
    "imo": [
        1484
    ],
    "idu-mishmi": [
        1520,
        1521
    ],
    "ida": [
        1520,
        1521
    ],
    "idu": [
        1520,
        1521
    ],
    "idu lhoba": [
        1520,
        1521
    ],
    "idu mishmi": [
        1520,
        1521
    ],
    "iscamtho": [
        1540,
        2402
    ],
    "isicamtho": [
        1540
    ],
    "inikana": [
        1563
    ],
    "iyiyiw-ayimiwin": [
        1612,
        1613
    ],
    "iyo’wujwa": [
        1617
    ],
    "inkijwas": [
        1617
    ],
    "iyo'wujwa chorote": [
        1617
    ],
    "iyowujwa": [
        1617
    ],
    "i’no’": [
        1617
    ],
    "ilois": [
        1619
    ],
    "iyojwa’ja": [
        1620
    ],
    "iyojwa'ja chorote": [
        1620
    ],
    "iyojwaja": [
        1620
    ],
    "island chumash": [
        1626
    ],
    "island chumashan": [
        1626
    ],
    "isleño": [
        1626
    ],
    "inilîmowin": [
        1652
    ],
    "iau": [
        7608,
        1751
    ],
    "ida’an": [
        1754,
        1755
    ],
    "ida'an": [
        1754,
        1755
    ],
    "idaan": [
        1754,
        1755,
        1989
    ],
    "idahan": [
        1754,
        1755
    ],
    "idan": [
        1754,
        1755
    ],
    "idayan": [
        1754,
        1755
    ],
    "ileo": [
        1812
    ],
    "idiŋ": [
        1867
    ],
    "idzing": [
        1867
    ],
    "intha-yaw": [
        1927
    ],
    "ilaga western dani": [
        1928
    ],
    "ilaga": [
        1928
    ],
    "idaksahak": [
        1975,
        1976
    ],
    "inagta alabat": [
        2005
    ],
    "inagta alabat agta": [
        2005
    ],
    "itunzu": [
        2045
    ],
    "iboo": [
        2054
    ],
    "iyace": [
        2088
    ],
    "ivbiosakon": [
        2102
    ],
    "itangimbesa": [
        2117
    ],
    "iteanghe-a-mbessa": [
        2117
    ],
    "ingilizce": [
        2118,
        2134,
        2146,
        2210
    ],
    "inglese": [
        2118,
        2134,
        2146,
        2210
    ],
    "ingliż": [
        2118,
        2134,
        2146,
        2210
    ],
    "inglés": [
        2118,
        2134,
        2146,
        2210
    ],
    "inglês": [
        2118,
        2134,
        2146,
        2210,
        2418,
        2424,
        2434
    ],
    "ie": [
        5969,
        5970,
        2162,
        2504,
        2505,
        2506,
        3250,
        4739,
        6116,
        6805,
        6806,
        7164
    ],
    "ireland": [
        2162,
        2504,
        2505,
        2506,
        3250,
        4739,
        6116,
        6805,
        6806,
        7164
    ],
    "im": [
        2164,
        2826
    ],
    "isle of man": [
        2164,
        2826
    ],
    "isle": [
        2164,
        2826
    ],
    "io": [
        2166
    ],
    "indian": [
        3224,
        6310,
        2166
    ],
    "imimkal": [
        2238
    ],
    "ibom": [
        2241
    ],
    "internacia": [
        2243
    ],
    "ic": [
        2274
    ],
    "inupiatun, north alaskan": [
        2291
    ],
    "inupiatun": [
        2291,
        3177
    ],
    "ieupiaq": [
        2291,
        3177
    ],
    "inuktitut, north alaskan": [
        2291
    ],
    "inuktitut": [
        3178,
        3281,
        3282,
        2291,
        3186,
        3187,
        3763
    ],
    "inupiak": [
        2291
    ],
    "inupiat": [
        2291,
        3177
    ],
    "iñupiaq": [
        2291,
        3177
    ],
    "iñupiatun": [
        2291,
        3177
    ],
    "inupiaq": [
        3177,
        2291
    ],
    "ieupiatun": [
        2291
    ],
    "ineskaya": [
        2300,
        2301
    ],
    "iniskaya": [
        2300,
        2301
    ],
    "iskaya’": [
        2300,
        2301
    ],
    "iton": [
        2308
    ],
    "iyekhee": [
        2310
    ],
    "iten": [
        2314,
        2868,
        3267
    ],
    "ilqan": [
        2317,
        2318
    ],
    "iranian": [
        6309,
        7706,
        2329
    ],
    "ichifipa": [
        2389
    ],
    "icifipa": [
        2389
    ],
    "isikhumsha": [
        2402
    ],
    "isilololo": [
        2406
    ],
    "isipiki": [
        2406
    ],
    "iatê": [
        2492
    ],
    "irish": [
        2504,
        2505,
        2506,
        3250,
        4739,
        6116,
        6805,
        6806,
        7164
    ],
    "irish gaelic": [
        2504,
        2505,
        2506
    ],
    "iliwaki": [
        2521
    ],
    "ilmedu": [
        2521
    ],
    "ilwaki": [
        2521
    ],
    "ibagyi": [
        2557
    ],
    "iukala": [
        2566
    ],
    "ivéa": [
        2610
    ],
    "i-kiribati": [
        2646
    ],
    "ikiribati": [
        2646
    ],
    "iro": [
        2679
    ],
    "ilao": [
        2760
    ],
    "ianomami": [
        2822
    ],
    "ikolen": [
        2835
    ],
    "ikõleey": [
        2835
    ],
    "ikõlej": [
        2835
    ],
    "ikõro": [
        2835
    ],
    "igihangaza": [
        2898
    ],
    "igiha": [
        2901
    ],
    "ikiha": [
        2901
    ],
    "israeli": [
        3257,
        2921,
        2922
    ],
    "ibito": [
        2938
    ],
    "illogo": [
        2948,
        2949
    ],
    "ilonggo": [
        2948,
        2949
    ],
    "innoko": [
        3027
    ],
    "interlingua (international auxiliary language": [
        3109,
        3110
    ],
    "interlingua": [
        3109,
        3110
    ],
    "international": [
        3202,
        3109,
        3110
    ],
    "iaai": [
        3111
    ],
    "iai": [
        3111,
        3114
    ],
    "iatmul": [
        3112
    ],
    "iapama": [
        3113
    ],
    "iban": [
        3115,
        4364
    ],
    "iban sabah": [
        3115
    ],
    "ibibio": [
        3116
    ],
    "ibibyo": [
        3116
    ],
    "iwaidja": [
        3117
    ],
    "ibadjo": [
        3117
    ],
    "iwaidji": [
        3117
    ],
    "iwaydja": [
        3117
    ],
    "ibaram-efifa": [
        3118
    ],
    "ibanag": [
        3119
    ],
    "ibanak": [
        3119
    ],
    "ibaloi": [
        3121
    ],
    "inibaloi": [
        3121
    ],
    "ibadoy": [
        3121
    ],
    "ibaloy": [
        3121
    ],
    "igodor": [
        3121
    ],
    "ibami": [
        3122
    ],
    "ibino": [
        3123
    ],
    "ibeno": [
        3123
    ],
    "ibuno": [
        3123
    ],
    "ibuoro": [
        3124
    ],
    "ibu": [
        3125
    ],
    "ibani": [
        3126
    ],
    "itcha": [
        3127
    ],
    "icelandic sign language": [
        3129
    ],
    "icelandic": [
        3129,
        3245
    ],
    "itm": [
        3129
    ],
    "is": [
        3202,
        3129,
        3245
    ],
    "iceland": [
        3129,
        3245
    ],
    "islander english creole": [
        3130
    ],
    "islander": [
        3130
    ],
    "islander, san andrés creole": [
        3130
    ],
    "islander creole english": [
        3130
    ],
    "idakho-isukha-tiriki": [
        3134
    ],
    "idaxo-isuxa-tiriki": [
        3134
    ],
    "indo-portuguese": [
        3135
    ],
    "idon": [
        3136
    ],
    "idong": [
        3136
    ],
    "idaca": [
        3137
    ],
    "idaaca": [
        3137
    ],
    "idaasa": [
        3137
    ],
    "idaatcha": [
        3137
    ],
    "idaṣa": [
        3137
    ],
    "idáìtsà": [
        3137
    ],
    "idere": [
        3138
    ],
    "idi": [
        3139
    ],
    "indri": [
        3140
    ],
    "idesa": [
        3141
    ],
    "idaté": [
        3142
    ],
    "interlingue": [
        3144
    ],
    "ifugao, amganad": [
        3145
    ],
    "ifugao": [
        3145,
        3146,
        3150,
        3152,
        3153
    ],
    "ifugao mun’alyon": [
        3145
    ],
    "ifugaw": [
        3145,
        3146,
        3150,
        3152
    ],
    "ifugao, batad": [
        3146
    ],
    "ifè": [
        3147,
        3148
    ],
    "ife": [
        3147,
        3148
    ],
    "ifo": [
        3149
    ],
    "ifugao, tuwali": [
        3150
    ],
    "ifugao, mayoyao": [
        3152
    ],
    "ibo": [
        3154,
        3209,
        8284,
        8285
    ],
    "ibara": [
        3155
    ],
    "igbarra": [
        3155
    ],
    "igbira": [
        3155
    ],
    "igbirra": [
        3155
    ],
    "igede": [
        3156
    ],
    "igedde": [
        3156
    ],
    "igana": [
        3157
    ],
    "igala": [
        3158
    ],
    "igara": [
        3158
    ],
    "igom": [
        3159
    ],
    "ignaciano": [
        3160
    ],
    "inaciànurupi": [
        3160
    ],
    "ignaciano mojo": [
        3160
    ],
    "isebe": [
        3161
    ],
    "interglossa": [
        3162,
        3163
    ],
    "igwe": [
        3164
    ],
    "iha based pidgin": [
        3165
    ],
    "iha": [
        3165,
        3167
    ],
    "ihievbe": [
        3166
    ],
    "izon": [
        3172
    ],
    "ijo": [
        3176,
        3172,
        3173
    ],
    "ijaw": [
        3172,
        3176
    ],
    "ijon": [
        3172
    ],
    "izo": [
        3172
    ],
    "ije": [
        3174
    ],
    "ijo, southeast": [
        3176
    ],
    "inupiatun, northwest alaska": [
        3177
    ],
    "inuktitut, eastern canadian": [
        3178,
        3281
    ],
    "inuit": [
        3185,
        3178,
        3186,
        3187,
        3281
    ],
    "inuit of quebec": [
        3178,
        3281
    ],
    "iko": [
        3179,
        8037
    ],
    "ikulu": [
        3181
    ],
    "ikolu": [
        3181
    ],
    "ikpeshi": [
        3183
    ],
    "ikpeshe": [
        3183
    ],
    "ikaranggal": [
        3184
    ],
    "ikarranggal": [
        3184
    ],
    "ikarranggali": [
        3184
    ],
    "inuit sign language": [
        3185
    ],
    "isl": [
        3185,
        3219,
        3224,
        3257
    ],
    "iur": [
        3185
    ],
    "inuit uukturausingit": [
        3185
    ],
    "inuk sign language": [
        3185
    ],
    "inuk": [
        3185
    ],
    "inuinnaqtun": [
        3186,
        3187
    ],
    "inuktun": [
        3186,
        3187
    ],
    "iku-gora-ankwa": [
        3188
    ],
    "ikwere": [
        3189
    ],
    "ikwerre": [
        3189
    ],
    "ikwerri": [
        3189
    ],
    "ik": [
        3190
    ],
    "icetod": [
        3190
    ],
    "icietot": [
        3190
    ],
    "ikizu": [
        3191
    ],
    "ikiikiizu": [
        3191
    ],
    "ikikizo": [
        3191
    ],
    "ikikizu": [
        3191
    ],
    "ile ape": [
        3192
    ],
    "ile": [
        3192
    ],
    "ila": [
        3193
    ],
    "ili turki": [
        3195
    ],
    "ili": [
        3195
    ],
    "ili turk": [
        3195
    ],
    "ilongot": [
        3196
    ],
    "iranun": [
        3197,
        3201
    ],
    "ilanun": [
        3197,
        3201
    ],
    "illanoan": [
        3197
    ],
    "illanoon": [
        3197
    ],
    "illanos": [
        3197
    ],
    "illanun": [
        3197,
        3201
    ],
    "iranon maranao": [
        3197
    ],
    "iranon": [
        3197
    ],
    "iranum": [
        3197
    ],
    "iranun (malaysia)": [
        3197
    ],
    "ilocano": [
        3198,
        3199,
        3200
    ],
    "ilokano": [
        3198,
        3199,
        3200
    ],
    "iloko": [
        3198,
        3199,
        3200
    ],
    "iranun (philippines)": [
        3201
    ],
    "international sign": [
        3202
    ],
    "international sign language": [
        3202
    ],
    "ili’uun": [
        3203
    ],
    "ili'uun": [
        3203
    ],
    "iliun": [
        3203
    ],
    "ilmaumau": [
        3203
    ],
    "ilue": [
        3204
    ],
    "idua": [
        3204
    ],
    "ikundun": [
        3206
    ],
    "imonda": [
        3208
    ],
    "imbongu": [
        3209
    ],
    "ibo ugu": [
        3209
    ],
    "imbo ungo": [
        3209
    ],
    "imbo": [
        3209,
        9103
    ],
    "imbo ungu": [
        3209
    ],
    "imbonggo": [
        3209
    ],
    "imroing": [
        3210
    ],
    "imroin": [
        3210
    ],
    "inga": [
        3213,
        3218,
        6407
    ],
    "ingush": [
        3215,
        3216,
        3217
    ],
    "ingus": [
        3215,
        3216,
        3217
    ],
    "ingushi": [
        3215,
        3216,
        3217
    ],
    "inga, jungle": [
        3218
    ],
    "ingano": [
        3218,
        6424
    ],
    "indonesian sign language": [
        3219
    ],
    "isinay": [
        3221
    ],
    "inmeas": [
        3221
    ],
    "isinai": [
        3221
    ],
    "inoke-yate": [
        3222
    ],
    "inoke": [
        3222
    ],
    "iñapari": [
        3223
    ],
    "inamari": [
        3223
    ],
    "indian sign language": [
        3224,
        6310
    ],
    "ishara": [
        3224
    ],
    "ipsl": [
        3224,
        6177
    ],
    "indo-pakistani sign language": [
        3224,
        6177
    ],
    "indo-pakistani": [
        3224,
        6177
    ],
    "intha": [
        3225
    ],
    "inntha": [
        3225
    ],
    "insa": [
        3225
    ],
    "ineseño": [
        3226
    ],
    "inezeño": [
        3226
    ],
    "inez": [
        3226
    ],
    "ido": [
        3227
    ],
    "inor": [
        3228
    ],
    "irumu": [
        3229
    ],
    "iowa-oto": [
        3230
    ],
    "iowa-oto-missouria": [
        3230
    ],
    "ipili": [
        3231
    ],
    "ipili-paiela": [
        3231
    ],
    "ipili-payala": [
        3231
    ],
    "ipiko": [
        3232
    ],
    "ipikoi": [
        3232
    ],
    "iquitu": [
        3233
    ],
    "ikito": [
        3233
    ],
    "ikitu": [
        3233
    ],
    "iquita": [
        3233
    ],
    "iquito": [
        3233
    ],
    "ikwo": [
        3234
    ],
    "iresim": [
        3235
    ],
    "irarutu": [
        3236
    ],
    "irahutu": [
        3236
    ],
    "irutu": [
        3236
    ],
    "idafan": [
        3237
    ],
    "iregwe": [
        3237
    ],
    "irigwe": [
        3237
    ],
    "iraqw": [
        3238
    ],
    "iraku": [
        3238
    ],
    "iraqu": [
        3238
    ],
    "irántxe": [
        3239
    ],
    "iranche": [
        3239
    ],
    "iranshe": [
        3239
    ],
    "iranxe": [
        3239
    ],
    "irula": [
        3241,
        3242
    ],
    "irava": [
        3241,
        3242
    ],
    "irulan": [
        3241,
        3242
    ],
    "irular": [
        3241,
        3242
    ],
    "irular mozhi": [
        3241,
        3242
    ],
    "irulavan": [
        3241,
        3242
    ],
    "iruliga": [
        3241,
        3242
    ],
    "iruligar": [
        3241,
        3242
    ],
    "iria": [
        3243
    ],
    "iraya mangyan": [
        3244
    ],
    "isabi": [
        3246
    ],
    "isconahua": [
        3247
    ],
    "iscobaquebu": [
        3247
    ],
    "iskobákebo": [
        3247
    ],
    "iskonawa": [
        3247
    ],
    "isnag": [
        3248
    ],
    "isneg": [
        3248
    ],
    "italian sign language": [
        3249
    ],
    "italian": [
        3249,
        3260,
        3261,
        3262,
        3263,
        3264
    ],
    "italiana": [
        3249,
        6944
    ],
    "irish sign language": [
        3250
    ],
    "isa": [
        3251
    ],
    "ishan": [
        3251
    ],
    "ishkashimi": [
        3253
    ],
    "ishkashim": [
        3253
    ],
    "ishkashmi": [
        3253
    ],
    "isanzu": [
        3255
    ],
    "ihaanzu": [
        3255
    ],
    "issansu": [
        3255
    ],
    "isoko": [
        3256
    ],
    "israeli sign language": [
        3257
    ],
    "istriot": [
        3258
    ],
    "istriano": [
        3258
    ],
    "istro-romance": [
        3258
    ],
    "isu": [
        3259,
        7293
    ],
    "isu (menchum division)": [
        3259
    ],
    "italiano": [
        3260,
        3262,
        3263,
        3264,
        3261
    ],
    "italiană": [
        3260,
        3261
    ],
    "italien": [
        3260,
        3261
    ],
    "italienisch": [
        3260,
        3261
    ],
    "italijanski": [
        3260,
        3261
    ],
    "itneg, binongan": [
        3265
    ],
    "itene": [
        3267
    ],
    "iteneo": [
        3267
    ],
    "iténez": [
        3267
    ],
    "itneg, inlaod": [
        3268
    ],
    "inlaod": [
        3268
    ],
    "inlaod itneg": [
        3268
    ],
    "italkian": [
        3269
    ],
    "itelmen": [
        3270
    ],
    "itelymem": [
        3270
    ],
    "itu mbon uzo": [
        3271
    ],
    "itu": [
        3271
    ],
    "itu mbon uso": [
        3271
    ],
    "itu mbuzo": [
        3271
    ],
    "itonama": [
        3272
    ],
    "itonama-saramo": [
        3272
    ],
    "itoname": [
        3272
    ],
    "iteri": [
        3273
    ],
    "iyo": [
        5333,
        3273
    ],
    "isekiri": [
        3274
    ],
    "irhobo": [
        3274
    ],
    "iselema-otu": [
        3274
    ],
    "ishekiri": [
        3274
    ],
    "itsekiri": [
        3274
    ],
    "iwere": [
        3274
    ],
    "izekíri": [
        3274
    ],
    "iṣekiri": [
        3274
    ],
    "itneg, maeng": [
        3275
    ],
    "itawit": [
        3276
    ],
    "itawes": [
        3276
    ],
    "itawis": [
        3276
    ],
    "ito": [
        3277
    ],
    "itik": [
        3278
    ],
    "ittik": [
        3278
    ],
    "ittik-tor": [
        3278
    ],
    "itneg, moyadan": [
        3279
    ],
    "itza’": [
        3280
    ],
    "icaiche maya": [
        3280
    ],
    "icaiche": [
        3280
    ],
    "itz": [
        3280
    ],
    "itzaj": [
        3280
    ],
    "itzaj maya": [
        3280
    ],
    "itzá": [
        3280
    ],
    "itzá maya": [
        3280
    ],
    "iu mien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "iu": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "iu mienh": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "ibatan": [
        3288,
        3289
    ],
    "ibataan": [
        3288
    ],
    "ivatan": [
        3289,
        3288
    ],
    "ivatanen": [
        3289
    ],
    "i-wak": [
        3290
    ],
    "iwaak": [
        3290
    ],
    "iwam": [
        3291,
        3293
    ],
    "iwoer": [
        3292
    ],
    "iwur": [
        3292
    ],
    "iwam, sepik": [
        3293
    ],
    "ixcatec": [
        3294
    ],
    "ixcateco": [
        3294
    ],
    "ixil": [
        3295
    ],
    "iyayu": [
        3296
    ],
    "idoani": [
        3296
    ],
    "iyon": [
        3297
    ],
    "iyaa": [
        3298
    ],
    "iyaka": [
        3298,
        8722
    ],
    "ingrian": [
        3299
    ],
    "ingermanlandian": [
        3299
    ],
    "inkeroisen": [
        3299
    ],
    "isuri keel": [
        3299
    ],
    "isuri": [
        3299
    ],
    "izhor": [
        3299
    ],
    "izhorian": [
        3299
    ],
    "ižoran": [
        3299
    ],
    "ižoran keel": [
        3299
    ],
    "ižoran keeli": [
        3299
    ],
    "izere": [
        3300
    ],
    "izarek": [
        3300
    ],
    "izer": [
        3300
    ],
    "izii": [
        3301
    ],
    "izhi": [
        3301
    ],
    "izi": [
        3301
    ],
    "izzi": [
        3301
    ],
    "inku": [
        3320
    ],
    "iba": [
        3328
    ],
    "ibut": [
        3365
    ],
    "il-ishaarah": [
        3414
    ],
    "il-urduniyyah": [
        3414
    ],
    "içuã tupi": [
        3426
    ],
    "içuã": [
        3426
    ],
    "iuruna": [
        3438
    ],
    "ikalahan": [
        3469
    ],
    "iwal": [
        3489
    ],
    "ikaan": [
        3511
    ],
    "ikani": [
        3511
    ],
    "ikalanga": [
        3516
    ],
    "ikokolemu": [
        3540
    ],
    "ikumama": [
        3540,
        7421
    ],
    "ikikerebe": [
        3561
    ],
    "ikela": [
        3569
    ],
    "imbak": [
        3577
    ],
    "imbatski-ket": [
        3577
    ],
    "individual": [
        3688,
        3832,
        3833,
        7234,
        7235,
        9077,
        9078,
        9108,
        9109
    ],
    "ikibungu": [
        3689
    ],
    "in-lom": [
        3748
    ],
    "ikaiku": [
        3753
    ],
    "imudji": [
        3761
    ],
    "ikota": [
        3865
    ],
    "ikuta": [
        3865
    ],
    "isana": [
        3875
    ],
    "iny": [
        3883
    ],
    "ibukwo": [
        3884
    ],
    "ikpan": [
        3884
    ],
    "ikposo": [
        3888
    ],
    "ikposso": [
        3888
    ],
    "igora": [
        3903
    ],
    "indios gigantes": [
        3931
    ],
    "i’saka": [
        3962
    ],
    "i'saka": [
        3962
    ],
    "isaka": [
        3962
    ],
    "isaro": [
        3966
    ],
    "igikuria": [
        4023
    ],
    "ikikuria": [
        4023
    ],
    "ingalik": [
        4035
    ],
    "iwoyo": [
        4096
    ],
    "ikokola": [
        4173
    ],
    "irangi": [
        4195
    ],
    "ichilambya": [
        4201
    ],
    "icilambya": [
        4201
    ],
    "icirambia": [
        4201
    ],
    "iramba": [
        4201,
        5479
    ],
    "ilyamba": [
        4201
    ],
    "ichilamba": [
        4205
    ],
    "i to": [
        4235
    ],
    "idṹ": [
        4253
    ],
    "idun": [
        4253
    ],
    "inyima": [
        4255
    ],
    "igonzabale": [
        4266
    ],
    "ileka-igonzabale": [
        4266
    ],
    "ileka ishile": [
        4306
    ],
    "ileka": [
        4306
    ],
    "ishile": [
        4306
    ],
    "isile": [
        4306
    ],
    "ikpana": [
        4308
    ],
    "irendely": [
        4355
    ],
    "ilolo": [
        4375
    ],
    "ilaali": [
        4382
    ],
    "inonhan": [
        4442
    ],
    "inkongo": [
        4524
    ],
    "ilumbu": [
        4530
    ],
    "ilianen": [
        4607
    ],
    "ilianen manobo": [
        4607
    ],
    "itundujia": [
        4629
    ],
    "itundujia mixtec": [
        4629
    ],
    "il-lingwa tas-sinjali maltija": [
        4663
    ],
    "il-lingwa": [
        4663
    ],
    "isongo": [
        4665
    ],
    "issongo": [
        4665
    ],
    "ikobi": [
        4681
    ],
    "ikobi kairi": [
        4681
    ],
    "ikobi-mena": [
        4681
    ],
    "ifunubwa": [
        4723
    ],
    "indonesian, makassar": [
        4725
    ],
    "idio": [
        4729
    ],
    "idien": [
        4729
    ],
    "imakua": [
        4747
    ],
    "imeetto": [
        4747
    ],
    "idne": [
        4751
    ],
    "ishimalilia": [
        4757
    ],
    "ichimambwe": [
        4758
    ],
    "island margu": [
        4773
    ],
    "illinois": [
        4791
    ],
    "isthmus": [
        4810,
        5465,
        8984,
        9126
    ],
    "isthmus mixe": [
        4810
    ],
    "istmo": [
        4810,
        5458,
        5465,
        8984
    ],
    "inavan petch": [
        4839
    ],
    "inavan": [
        4839
    ],
    "ilwana": [
        4884
    ],
    "innu": [
        4963,
        5690,
        5691
    ],
    "innu aimun": [
        4963,
        5690,
        5691
    ],
    "innu aionun": [
        4963
    ],
    "ingli": [
        5010
    ],
    "inner mongolian": [
        5155,
        5156
    ],
    "inner": [
        5155,
        5156
    ],
    "indus": [
        8488,
        5173
    ],
    "indus kohistani": [
        5173
    ],
    "ichinamwanga": [
        5186
    ],
    "inamwanga": [
        5186
    ],
    "ifara-mele": [
        5209
    ],
    "ifira-mele": [
        5209
    ],
    "ide": [
        5253
    ],
    "ixcatlán": [
        5264
    ],
    "ixcatlán mazatec": [
        5264
    ],
    "inapang": [
        5276
    ],
    "iguta": [
        5301
    ],
    "ingwe": [
        5303
    ],
    "ingwo": [
        5303
    ],
    "imela": [
        5317
    ],
    "imemai": [
        5317
    ],
    "imemüi": [
        5317
    ],
    "inmwen": [
        5325
    ],
    "isn": [
        5352
    ],
    "idioma de señas de nicaragua": [
        5352
    ],
    "idioma": [
        5352
    ],
    "isindebele": [
        5358,
        5661,
        5662
    ],
    "isinde’bele": [
        5358
    ],
    "ici-ndali": [
        5365
    ],
    "icindali": [
        5365
    ],
    "indaaka": [
        5368
    ],
    "ingundi": [
        5371
    ],
    "ilkan beye": [
        5395
    ],
    "ilkan": [
        5395
    ],
    "iwatenu": [
        5401
    ],
    "ilomwe": [
        5431
    ],
    "ingulu": [
        5431
    ],
    "ikingurimi": [
        5435
    ],
    "isthmus-cosoleacaque": [
        5454
    ],
    "isthmus-cosoleacaque nahuatl": [
        5454
    ],
    "istmo-cosoleacaque": [
        5454
    ],
    "isthmus-pajapan": [
        5458
    ],
    "isthmus-pajapan nahuatl": [
        5458
    ],
    "isthmus-mecayapan": [
        5465
    ],
    "isthmus aztec-mecayapan": [
        5465
    ],
    "isthmus nahuat": [
        5465
    ],
    "isthmus nahuatl": [
        5465
    ],
    "isthmus-mecayapan nahuatl": [
        5465
    ],
    "ishinyiha": [
        5474
    ],
    "isinyixa": [
        5474
    ],
    "ikinilamba": [
        5479
    ],
    "ikiniramba": [
        5479
    ],
    "ilamba": [
        5479
    ],
    "ilinilamba": [
        5479
    ],
    "incha": [
        5480
    ],
    "ishiwanda": [
        5495
    ],
    "inpui": [
        5516
    ],
    "inpui naga": [
        5516
    ],
    "ingul": [
        5553
    ],
    "inato": [
        5635
    ],
    "ina’o": [
        5635
    ],
    "inthome": [
        5635
    ],
    "intsome": [
        5635
    ],
    "isikhethu": [
        5661,
        5662
    ],
    "injang": [
        5666
    ],
    "isachanure": [
        5681
    ],
    "iyuw imuun": [
        5690,
        5691
    ],
    "iyuw": [
        5690,
        5691
    ],
    "imuun": [
        5690,
        5691
    ],
    "iyimuuun": [
        5690,
        5691
    ],
    "ikoma-nata-isenye": [
        5715
    ],
    "inukuini": [
        5726
    ],
    "ilngali": [
        5730
    ],
    "indinogosima": [
        5749
    ],
    "inyimang": [
        5795
    ],
    "inyanga": [
        5796
    ],
    "ikingonde": [
        5811
    ],
    "ikinyakyusa": [
        5811
    ],
    "ikinyikyusa": [
        5811
    ],
    "i-nzèbi": [
        5813
    ],
    "injebi": [
        5813
    ],
    "inzabi": [
        5813
    ],
    "inzebi": [
        5813
    ],
    "indzéé": [
        5814
    ],
    "inebu": [
        5858
    ],
    "inebu one": [
        5858
    ],
    "ikobo": [
        5873
    ],
    "ihatum": [
        5977
    ],
    "ixtenco": [
        5997
    ],
    "ixtenco otomi": [
        5997
    ],
    "ineisine": [
        6059
    ],
    "inés": [
        6060,
        9133
    ],
    "indonesian, peranakan": [
        6089
    ],
    "ichipimbwe": [
        6162
    ],
    "icipimbwe": [
        6162
    ],
    "isharon ki zubann": [
        6177
    ],
    "isharon": [
        6177
    ],
    "iranian sign language": [
        6309
    ],
    "irani": [
        6309
    ],
    "indian language of signs": [
        6310
    ],
    "ipounou": [
        6370
    ],
    "ipunu": [
        6370
    ],
    "inkawasi-kañaris runashimi": [
        6400
    ],
    "inkawasi-kañaris": [
        6400
    ],
    "incahuasi-cañaris": [
        6400
    ],
    "inka": [
        6407
    ],
    "imbabura": [
        6419
    ],
    "imbabura highland quichua": [
        6419
    ],
    "imbabura quichua": [
        6419
    ],
    "in’ambreŋgɨ": [
        6549
    ],
    "iberian romani": [
        6558
    ],
    "iberian": [
        8482,
        6558
    ],
    "ikirundi": [
        6566,
        6567
    ],
    "ichirungwa": [
        6574
    ],
    "icilungwa": [
        6574
    ],
    "ini": [
        6587
    ],
    "ikiruguru": [
        6621
    ],
    "inchazi": [
        6625
    ],
    "istro": [
        6626
    ],
    "istrio-romanian": [
        6626
    ],
    "istro romanian": [
        6626
    ],
    "istro-romanian": [
        6626
    ],
    "ikinyarwanda": [
        6635,
        6636
    ],
    "ishisafwa": [
        6701
    ],
    "ishisangu": [
        6706
    ],
    "ishisango": [
        6706
    ],
    "ikuhane": [
        6709
    ],
    "iitom": [
        6782
    ],
    "ikä caning": [
        6840
    ],
    "ikä": [
        6840
    ],
    "isaalang": [
        6877
    ],
    "isaalung": [
        6877
    ],
    "issala": [
        6877,
        7140
    ],
    "ijlaan n siwaan": [
        6888
    ],
    "ijlaan": [
        6888
    ],
    "isala": [
        6942
    ],
    "iui": [
        6949
    ],
    "inari": [
        6974
    ],
    "inari sami": [
        6974
    ],
    "isangu": [
        7008
    ],
    "imasi": [
        7025
    ],
    "itsong": [
        7038
    ],
    "isirawa": [
        7111
    ],
    "isiswazi": [
        7127
    ],
    "ikisimbëtë": [
        7130
    ],
    "irish traveler cant": [
        7164
    ],
    "ichira": [
        7237
    ],
    "ishira": [
        7237
    ],
    "isira": [
        7237
    ],
    "iou": [
        7243
    ],
    "indios do coxodoá": [
        7251
    ],
    "iagu": [
        7290
    ],
    "inanwatan": [
        7290
    ],
    "isu (fako division)": [
        7293
    ],
    "isubu": [
        7293
    ],
    "isuwu": [
        7293
    ],
    "ishang": [
        7308,
        7309,
        7310
    ],
    "ichitaabwa": [
        7315
    ],
    "ingassana": [
        7336
    ],
    "ingessana": [
        7336
    ],
    "igalan": [
        7379,
        7380,
        7381
    ],
    "iteghe": [
        7415
    ],
    "inaquen": [
        7416
    ],
    "ibali": [
        7418
    ],
    "ibali teke": [
        7418
    ],
    "iteso": [
        7421,
        7422
    ],
    "idarab mitstsi": [
        7508
    ],
    "idarab": [
        7508
    ],
    "itneg, masadiit": [
        7512
    ],
    "itneg adasen": [
        7514
    ],
    "inland tlingit": [
        7568,
        7569
    ],
    "inland": [
        7568,
        7569
    ],
    "iaw": [
        7608
    ],
    "inhambane": [
        7644
    ],
    "icitonga": [
        7645
    ],
    "istanbul turkish": [
        7694,
        7695,
        7696,
        7699
    ],
    "istanbul": [
        7694,
        7695,
        7696,
        7699
    ],
    "iranian azerbaijan jewish neo-aramaic": [
        7706
    ],
    "ijomi": [
        7708
    ],
    "itunyoso": [
        7716
    ],
    "iboho": [
        7722
    ],
    "icaangi": [
        7729
    ],
    "icaangui": [
        7729
    ],
    "itsaangi": [
        7729
    ],
    "itsangi": [
        7729
    ],
    "itsengi": [
        7729
    ],
    "i̇şaret": [
        7741
    ],
    "isaan": [
        7772
    ],
    "issan": [
        7772
    ],
    "imandi": [
        7781
    ],
    "ibeto": [
        7805
    ],
    "ingalkoyyu’": [
        7832
    ],
    "ingelshi": [
        7832
    ],
    "ikpeng": [
        7846
    ],
    "inafosa": [
        7861
    ],
    "imbo-ungu": [
        7900,
        7901,
        7902
    ],
    "ishua": [
        7926
    ],
    "iyive": [
        7929
    ],
    "ichishkíin": [
        7956,
        8148,
        8728
    ],
    "ileme": [
        7970
    ],
    "ineme": [
        7970
    ],
    "islami": [
        7987,
        7988,
        7989
    ],
    "itucale": [
        7992
    ],
    "itucali": [
        7992
    ],
    "itukale": [
        7992
    ],
    "iru-itu": [
        7995
    ],
    "itanga": [
        8008
    ],
    "isangele": [
        8018
    ],
    "itang": [
        8022
    ],
    "itank": [
        8022
    ],
    "it-hun": [
        8024
    ],
    "iaian": [
        8033
    ],
    "iduna": [
        8089
    ],
    "ija koro": [
        8095
    ],
    "ija": [
        8095
    ],
    "ixtayutla": [
        8113
    ],
    "ixtayutla mixtec": [
        8113
    ],
    "ienra naxinandana nnandia": [
        8127
    ],
    "ienra": [
        8127
    ],
    "ichiwanda": [
        8179
    ],
    "iciwanda": [
        8179
    ],
    "ilpara": [
        8187
    ],
    "ilpira": [
        8187
    ],
    "ilpirra": [
        8187
    ],
    "inningai": [
        8201,
        8782
    ],
    "iyanh": [
        8235
    ],
    "iyanja": [
        8235
    ],
    "itoto": [
        8322
    ],
    "iciwungu": [
        8366
    ],
    "indiang": [
        8418
    ],
    "isixhosa": [
        8472,
        8473
    ],
    "illyrian": [
        8484
    ],
    "ikomagi": [
        8485
    ],
    "indus valley language": [
        8488
    ],
    "ii": [
        8504
    ],
    "iverian": [
        8535
    ],
    "isyarat": [
        8541
    ],
    "iabali": [
        8571
    ],
    "ichikile": [
        8584
    ],
    "isanga": [
        8635
    ],
    "isaanga": [
        8638
    ],
    "ishanga": [
        8638
    ],
    "ita-ita": [
        8651
    ],
    "itha-itha": [
        8651
    ],
    "ithi-ithi": [
        8651
    ],
    "iti-iti": [
        8651
    ],
    "ilakuri wongi": [
        8695
    ],
    "ilakuri": [
        8695
    ],
    "iauminawa": [
        8717
    ],
    "iaca": [
        8722
    ],
    "iaka": [
        8722
    ],
    "iazgulem": [
        8724,
        8725
    ],
    "iaualapití": [
        8742
    ],
    "iyala": [
        8746
    ],
    "iyashi": [
        8752
    ],
    "iryavula": [
        8768,
        8769
    ],
    "itárók": [
        8775
    ],
    "inisine": [
        8777
    ],
    "iningai": [
        8782
    ],
    "iningayi": [
        8782
    ],
    "iraqi judeo-arabic": [
        8791
    ],
    "iraqi-baghdadi": [
        8791
    ],
    "ingara": [
        8795
    ],
    "ingarda": [
        8795
    ],
    "ingarra": [
        8795
    ],
    "ingarrah": [
        8795
    ],
    "inggarda": [
        8795
    ],
    "inparra": [
        8795
    ],
    "idin idindji": [
        8799
    ],
    "idin": [
        8799
    ],
    "idindji": [
        8799
    ],
    "idin-wudjar": [
        8799
    ],
    "idinji": [
        8799
    ],
    "indindji": [
        8799
    ],
    "indjibandi": [
        8800
    ],
    "inchalachee": [
        8802
    ],
    "inchalanche": [
        8802
    ],
    "indjilandji": [
        8802
    ],
    "indjilindji": [
        8802
    ],
    "indjurandji": [
        8802
    ],
    "indkilindji": [
        8802
    ],
    "injdjiladji": [
        8802
    ],
    "injilinji": [
        8802
    ],
    "intjilatja": [
        8802
    ],
    "iakaikeke": [
        8818
    ],
    "iyasa": [
        8822
    ],
    "iamalele": [
        8848
    ],
    "innamincka": [
        8859
    ],
    "iyansi": [
        8867
    ],
    "ibinda": [
        8878
    ],
    "iombe": [
        8878
    ],
    "ia": [
        8898
    ],
    "ia hrong": [
        8898
    ],
    "iron yao": [
        8898
    ],
    "iron": [
        8898
    ],
    "indigenous": [
        8898
    ],
    "iataj": [
        8918
    ],
    "inawangga": [
        8946
    ],
    "inawonga": [
        8946
    ],
    "inawongga": [
        8946
    ],
    "iauanauá": [
        8948
    ],
    "ixtlán zapoteco": [
        8969
    ],
    "ixtlán": [
        9123,
        8969,
        8973
    ],
    "ikizanaki": [
        8980
    ],
    "ilizanaki": [
        8980
    ],
    "istmeño": [
        8984
    ],
    "informal malay": [
        9077,
        9078
    ],
    "informal": [
        9077,
        9078
    ],
    "ixtlan zapotec": [
        9123
    ],
    "ixtlan": [
        9123
    ],
    "isizulu": [
        9172,
        9173
    ]
};
